"use strict";

var DataTypeConversionMixin, React;

React = require("react");

DataTypeConversionMixin = {
  propTypes: {
    dataType: React.PropTypes.string
  },
  convertDataType: function convertDataType(value) {
    var integer;
    switch (this.props.dataType) {
      case "boolean":
        switch (value) {
          case "true":
          case "1":
            return true;
          case "false":
          case "0":
            return false;
          default:
            return null;
        }
        break;
      case "number":
        if (value === "") {
          return null;
        } else {
          integer = parseInt(value, 10);
          if (integer.toString() === value) {
            return integer;
          } else {
            return value;
          }
        }
        break;
      default:
        if (value === "") {
          return null;
        } else {
          return value;
        }
    }
  }
};

module.exports = DataTypeConversionMixin;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/mixins/DataTypeConversion.js
 ** module id = 283
 ** module chunks = 0
 **/